export const OrientacoesTrilhaPssc = {
    instrucoes: 'Instruções'
};
